import React from "react";
import { Card, CardContent, Grid } from "@mui/material";
import { styled } from "@mui/system";
import { CustomLabel, CustomValue } from "./CustomTypography";

const StyledCard = styled(Card)(() => ({
  width: "100%",
  height: "100%",
  cursor: "pointer",
  border: "1px solid #A5A5A5",
  marginTop: "15px",
  position: "relative",
  backgroundColor: "#FFFFFF",
  // overflow: "scroll",
  "&:hover": {
    boxShadow: "0px 0px 10px 2px rgba(0,0,0,0.1)",
  },
  "&.disabled": {
    backgroundColor: "#E5E5E5",
    pointerEvents: "none",
    border: "1px solid #A5A5A5",
  },
}));

const ListGenericCard = ({
  title,
  subtitle,
  onClick,
  ImageFile,
  loanProposals,
}) => {
  const hasLoanProposals = loanProposals && loanProposals.length > 0;

  return (
    <StyledCard
      onClick={onClick}
      className={hasLoanProposals ? "disabled" : ""}
    >
      {hasLoanProposals && (
        <span
          style={{
            position: "absolute",
            top: "-5px",
            left: "5px",
            backgroundColor: "white",
            padding: "2px 5px",
            fontSize: "10px",
            color: "#4CAF50",
            zIndex: 1,
          }}
        >
          Proposal Sent
        </span>
      )}
      <CardContent
        style={{
          padding: "10px",
          marginTop: hasLoanProposals ? "-1px" : "0",
          opacity: hasLoanProposals ? 0.4 : 1, // Adjust opacity conditionally
        }}
      >
        {ImageFile ? (
          <>
            <Grid container>
              <Grid item xs={8}>
                <img src={ImageFile} width={80} height={40} />
              </Grid>
              <Grid item xs={4}>
                <CustomLabel>{title}</CustomLabel>
              </Grid>
            </Grid>
          </>
        ) : (
          <CustomLabel>{title}</CustomLabel>
        )}
        {subtitle && (
          <Grid container spacing={1}>
            {subtitle.map((sub, index) => (
              <Grid item key={index}>
                <CustomValue>{sub},</CustomValue>
              </Grid>
            ))}
          </Grid>
        )}
      </CardContent>
    </StyledCard>
  );
};

export default ListGenericCard;
